import { formatAmount } from '@shripos/shared/billing';

/** ₹ display from integer paise. */
export const rupees = (paise) => (paise == null ? '—' : `₹${formatAmount(paise)}`);

/** Rupee text from an input box → integer paise (null if blank/invalid). */
export function toPaise(value) {
  if (value === '' || value == null) return null;
  const n = Number(String(value).replace(/,/g, ''));
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

export const toRupeeInput = (paise) => (paise == null ? '' : (paise / 100).toFixed(2).replace(/\.00$/, ''));
